import "./styles.scss";

import PropTypes from "prop-types";
import React, { Suspense, lazy } from "react";

const Slider = lazy(() => import(/* webpackChunkName: "react-slick" */ "react-slick"));


const Carousel = ({ nextArrow = ">", prevArrow = "<", className = "", children, ...props }) => {
  const firstChild = React.Children.toArray(children)[0];

  // eslint-disable-next-line react/prop-types, no-unused-vars
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={"slick-prev slick-arrow" + (currentSlide === 0 ? " slick-disabled" : "")}
      title="previous"
      aria-disabled={currentSlide === 0 ? true : false}
      type="button"
    >
      {prevArrow}
    </button>
  );
  // eslint-disable-next-line react/prop-types
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={"slick-next slick-arrow" + (currentSlide === slideCount - 1 ? " slick-disabled" : "")}
      title="next"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
      type="button"
    >
      {nextArrow}
    </button>
  );

  return (
    <Suspense
      fallback={
        <div className="slick-slider">
          {firstChild}
          <div style={{ height: 38 }} />
        </div>
      }
    >
      <Slider nextArrow={<SlickArrowRight />} prevArrow={<SlickArrowLeft />} className={className} {...props}>
        {children}
      </Slider>
    </Suspense>
  );
};

Carousel.propTypes = {
  children: PropTypes.node.isRequired,
  nextArrow: PropTypes.node,
  prevArrow: PropTypes.node,
  className: PropTypes.string,
};

export default Carousel;
